export default __webpack_public_path__ + "static/float_gradation-top-bdc776593dd55cd62a5bb65e66e1bc7e.png";